(function eyewearFlowInit() {
	if (window.__eyewearFlowInit) return;
	window.__eyewearFlowInit = true;

	let mounted = false;
	let uiRefs = null;

	const FALLBACK_PACK_PRODUCT = {
		options: ['Type de verres', 'Pack'],
		variants: [
			{
				id: 56297242034520,
				title: "Simple / L'Essentiel - entree de gamme",
				available: true,
				price: 1999,
				option1: 'Simple',
				option2: "L'Essentiel - entree de gamme",
				option3: '',
			},
			{
				id: 56297242067288,
				title: 'Simple / Le confort - milieu de gamme',
				available: true,
				price: 2999,
				option1: 'Simple',
				option2: 'Le confort - milieu de gamme',
				option3: '',
			},
			{
				id: 56297242100056,
				title: 'Simple / Le Premium - haut de gamme',
				available: true,
				price: 4999,
				option1: 'Simple',
				option2: 'Le Premium - haut de gamme',
				option3: '',
			},
			{
				id: 56297242329432,
				title: "Progressifs / L'Essentiel - entree de gamme",
				available: true,
				price: 4499,
				option1: 'Progressifs',
				option2: "L'Essentiel - entree de gamme",
				option3: '',
			},
			{
				id: 56297242362200,
				title: 'Progressifs / Le confort - milieu de gamme',
				available: true,
				price: 5499,
				option1: 'Progressifs',
				option2: 'Le confort - milieu de gamme',
				option3: '',
			},
			{
				id: 56297242394968,
				title: 'Progressifs / Le Premium - haut de gamme',
				available: true,
				price: 6499,
				option1: 'Progressifs',
				option2: 'Le Premium - haut de gamme',
				option3: '',
			},
		],
	};

	const PACK_CATALOG = resolvePackCatalog();
	const LENS_TYPE_MAP = Object.fromEntries(PACK_CATALOG.types.map((lensType) => [lensType.key, lensType]));

	const TEXTS = {
		ready: 'Choix prets. Vous pouvez ajouter au panier.',
		needChoice: 'Completez vos choix pour continuer.',
		needLensType: 'Choisissez un type de verres.',
		needPack: 'Choisissez un pack de verres.',
		needUpload: 'Ordonnance requise avant ajout.',
		missingVariant: 'Ajout du pack en propriete (renseigner l ID de variante plus tard).',
	};

	const CONFIG = {
		autoSubmitFrameOnly: true,
		redirectAfterAdd: false,
	};
	const PENDING_PACK_STORAGE_KEY = 'eyewearFlowPendingPackV1';
	const MIRRORED_UPLOADERY_INPUT_ATTR = 'data-eyewear-uploadery-mirror';
	const NATIVE_UPLOAD_INPUT_ATTR = 'data-eyewear-native-upload';
	const UPLOADERY_FALLBACK_PROPERTY_NAME = 'properties[Uploadery_1]';
	const NATIVE_UPLOAD_PROPERTY_NAME = 'properties[Ordonnance]';
	let pendingPackProcessing = false;
	let pendingPackRetryTimer = null;
	let pendingPackRetryCount = 0;
	let lastUploaderyFile = '';
	let nativeUploadFile = null;
	let uploaderyMoveObserver = null;
	let uploaderyMoveRetryTimer = null;
	const PENDING_PACK_RETRY_DELAY = 450;
	const PENDING_PACK_MAX_RETRIES = 24;
	const UPLOADERY_MOVE_TIMEOUT = 20000;

	function resolvePackCatalog() {
		const catalog = buildCatalogFromProduct(readShopifyPackProduct());
		if (catalog.types.length) {
			return catalog;
		}
		return buildCatalogFromProduct(FALLBACK_PACK_PRODUCT);
	}

	function readShopifyPackProduct() {
		const dataEl = document.getElementById('EyewearFlowPackProduct');
		if (!dataEl) return null;

		try {
			return JSON.parse(dataEl.textContent || '{}');
		} catch (error) {
			console.warn('[eyewear-flow] Invalid pack product JSON', error);
			return null;
		}
	}

	function buildCatalogFromProduct(product) {
		if (!product?.variants?.length) {
			return {
				lensTypeOptionName: 'Type de verres',
				packOptionName: 'Pack',
				types: [],
			};
		}

		const optionConfig = resolveOptionConfig(product);
		const types = [];
		const typeIndexes = new Map();

		product.variants.forEach((variant, index) => {
			const lensTypeLabel = getVariantOptionValue(variant, optionConfig.lensTypeIndex) || `Type ${index + 1}`;
			const packTitle =
				getVariantOptionValue(variant, optionConfig.packIndex) || variant.title || `Pack ${index + 1}`;
			const lensTypeKey = slugify(lensTypeLabel) || `type-${index + 1}`;
			const packKey = `${lensTypeKey}__${slugify(packTitle) || `pack-${index + 1}`}`;

			if (!typeIndexes.has(lensTypeKey)) {
				typeIndexes.set(lensTypeKey, types.length);
				types.push({
					key: lensTypeKey,
					label: lensTypeLabel,
					packs: [],
				});
			}

			const packMeta = resolvePackMeta(variant, packTitle);
			types[typeIndexes.get(lensTypeKey)].packs.push({
				key: packKey,
				title: packTitle,
				description: packMeta.description,
				badge: packMeta.badge,
				requiresUpload: true,
				variantId: Number(variant.id) || null,
				price: typeof variant.price === 'number' ? variant.price : Number(variant.price || 0),
				compareAtPrice:
					typeof variant.compareAtPrice === 'number'
						? variant.compareAtPrice
						: Number(variant.compareAtPrice || 0) || null,
				available: variant.available !== false,
				sku: variant.sku || '',
				option1: variant.option1 || '',
				option2: variant.option2 || '',
				option3: variant.option3 || '',
				lensTypeKey,
				lensTypeLabel,
			});
		});

		return {
			lensTypeOptionName: optionConfig.lensTypeName,
			packOptionName: optionConfig.packName,
			types: types.filter((type) => type.packs.length),
		};
	}

	function resolveOptionConfig(product) {
		const optionNames = Array.isArray(product?.options) ? product.options : [];
		const normalizedOptions = optionNames.map((value) => normalizeValue(value));

		let lensTypeIndex = normalizedOptions.findIndex((value) => value.includes('type') && value.includes('verre'));
		if (lensTypeIndex === -1) {
			lensTypeIndex = normalizedOptions.findIndex((value) => value.includes('verre'));
		}
		if (lensTypeIndex === -1) {
			lensTypeIndex = 0;
		}

		let packIndex = normalizedOptions.findIndex((value) => value.includes('pack'));
		if (packIndex === -1) {
			packIndex = optionNames.length > 1 ? (lensTypeIndex === 0 ? 1 : 0) : 1;
		}

		return {
			lensTypeIndex,
			packIndex,
			lensTypeName: optionNames[lensTypeIndex] || 'Type de verres',
			packName: optionNames[packIndex] || 'Pack',
		};
	}

	function getVariantOptionValue(variant, index) {
		if (index === 0) return variant?.option1 || '';
		if (index === 1) return variant?.option2 || '';
		if (index === 2) return variant?.option3 || '';
		return '';
	}

	function resolvePackMeta(variant, packTitle) {
		const metafieldBadge = normalizeText(variant?.packBadge);
		const metafieldDescription = normalizeText(variant?.packDescription);
		const inferredMeta = inferPackMeta(packTitle);

		return {
			badge: metafieldBadge || inferredMeta.badge,
			description: metafieldDescription || inferredMeta.description,
		};
	}

	function inferPackMeta(packTitle) {
		const normalizedTitle = normalizeValue(packTitle);

		if (normalizedTitle.includes('entree') || normalizedTitle.includes('essentiel')) {
			return { badge: 'Entree de gamme', description: '' };
		}
		if (normalizedTitle.includes('milieu') || normalizedTitle.includes('confort')) {
			return { badge: 'Milieu de gamme', description: '' };
		}
		if (normalizedTitle.includes('haut') || normalizedTitle.includes('premium')) {
			return { badge: 'Haut de gamme', description: '' };
		}

		return { badge: '', description: '' };
	}

	function normalizeText(value) {
		return String(value || '').trim();
	}

	function normalizeValue(value) {
		return String(value || '')
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '');
	}

	function slugify(value) {
		return normalizeValue(value)
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '');
	}

	document.addEventListener('DOMContentLoaded', () => {
		bootstrap();
		schedulePendingPackProcessing(250);
	});
	document.addEventListener('cart:update', () => {
		schedulePendingPackProcessing(120);
	});

	function bootstrap() {
		const template = document.querySelector('#MainContent')?.dataset.template || '';
		if (!template.startsWith('product')) {
			return; // Ne pas monter le configurateur hors des pages produit
		}

		const found = findProductForm();
		if (!found.productDetails || !found.form) {
			console.warn('[eyewear-flow] Form not found at DOMContentLoaded, will observe for it.');
			observeForForm();
			return;
		}

		mountFlow(found.productDetails, found.form);
	}

	function mountFlow(productDetails, form) {
		if (mounted) return;
		mounted = true;

		console.info('[eyewear-flow] Mounting on', productDetails);

		const buyButtonsBlock = productDetails.querySelector('.buy-buttons-block') || form;
		const insertionParent = buyButtonsBlock?.parentElement || form.parentElement || productDetails;
		const beforeNode = buyButtonsBlock || form;

		const state = {
			mode: null, // 'frame-only' | 'rx'
			lensType: null, // lens type key from pack product options
			pack: null,
			uploadDone: false,
			pending: false,
			pendingToken: null,
		};

		const hiddenPackProperty = ensureHiddenInput(form, 'properties[Pack de verres]', '');
		const hiddenFlowProperty = ensureHiddenInput(form, 'properties[Monture]', '');
		const hiddenFlowToken = ensureHiddenInput(form, 'properties[_eyewear_flow_token]', '');

		const ui = buildUi();
		uiRefs = ui;
		try {
			if (insertionParent && beforeNode && insertionParent.isConnected) {
				insertionParent.insertBefore(ui.container, beforeNode);
			} else {
				productDetails.appendChild(ui.container);
			}
		} catch (err) {
			console.error('[eyewear-flow] Failed to insert UI', err);
			productDetails.appendChild(ui.container);
		}

		moveUploaderyInto(ui.uploadWrapper);

		const uploaderyClassTarget = document.body;

		console.info('[eyewear-flow] Initialized');

		bindEvents();
		bindUploaderyEvents();
		loadPackPrices();
		syncUi();

		function bindEvents() {
			ui.frameOnlyBtn.addEventListener('click', () => {
				state.mode = 'frame-only';
				state.lensType = null;
				state.pack = null;
				state.uploadDone = true;
				state.pending = false;
				state.pendingToken = null;
				clearPendingPack();
				lastUploaderyFile = '';
				nativeUploadFile = null;
				clearUploaderyMirrors(form);
				hiddenFlowToken.value = '';
				syncUi();
				if (CONFIG.autoSubmitFrameOnly) {
					submitItems(buildItems(), true);
				}
			});

			ui.rxBtn.addEventListener('click', () => {
				state.mode = 'rx';
				state.uploadDone = false;
				syncUi();
			});

			ui.lensTypeButtons.forEach((lensTypeBtn) => {
				lensTypeBtn.addEventListener('click', () => {
					state.mode = 'rx';
					state.lensType = lensTypeBtn.dataset.lensTypeKey || null;
					state.pack = null;
					state.uploadDone = false;
					syncUi();
				});
			});

			ui.packCards.forEach((card) => {
				card.addEventListener('click', () => {
					if (!state.lensType) return;
					if (card.pack.available === false) return;
					state.mode = 'rx';
					state.pack = card.pack;
					state.uploadDone = card.pack.requiresUpload ? Boolean(state.uploadDone || nativeUploadFile || lastUploaderyFile) : true;
					syncUi();
				});
			});

			form.addEventListener(
				'submit',
				(event) => {
					if (!isReady()) {
						event.preventDefault();
						event.stopImmediatePropagation();
						setStatus(TEXTS.needChoice, true);
						return;
					}

					const items = buildItems();
					const hasLensVariant = state.pack && state.pack.variantId;

					updateHiddenProperties();
					syncUploaderyPropertiesToProductForm(form);

					if (state.mode === 'frame-only') {
						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
						submitItems(items, state.mode === 'frame-only');
						return;
					}

					const submitter = event.submitter;
					const acceleratedCheckout = Boolean(
						submitter instanceof HTMLElement && submitter.closest('.shopify-payment-button')
					);

					if (acceleratedCheckout) {
						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
						setStatus('Le paiement express n est pas disponible avec ordonnance.', true);
						return;
					}

					if (state.mode === 'rx' && hasLensVariant) {
						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
						clearPendingPack();
						hiddenFlowToken.value = '';
						submitItems(items, false);
						return;
					}
				},
				true,
			);

			document.addEventListener('eyewear-flow:pending-pack-complete', (event) => {
				if (event.detail?.token !== state.pendingToken) return;
				state.pending = false;
				state.pendingToken = null;
				setStatus('Ajout au panier.', false);
				syncUi();
			});

			document.addEventListener('eyewear-flow:pending-pack-error', (event) => {
				if (event.detail?.token !== state.pendingToken) return;
				state.pending = false;
				state.pendingToken = null;
				setStatus('Le pack de verres n a pas pu etre ajoute automatiquement.', true);
				syncUi();
			});

			document.addEventListener('cart:error', () => {
				if (!state.pendingToken) return;
				clearPendingPack(state.pendingToken);
				state.pending = false;
				state.pendingToken = null;
				setStatus('Impossible d ajouter au panier pour le moment.', true);
				syncUi();
			});
		}

		function buildUi() {
			const container = el('div', 'eyewear-flow');

			const header = el('div', 'eyewear-flow__header');
			const title = el('p', 'eyewear-flow__title', 'Choisissez vos options de verres');
			const subtitle = el(
				'p',
				'eyewear-flow__subtitle',
				'Monture seule ou verres correcteurs (Uploadery uniquement si ordonnance requise).',
			);
			header.append(title, subtitle);

			const actions = el('div', 'eyewear-flow__actions');
			const frameOnlyBtn = button('Monture seule', 'eyewear-flow__btn');
			const rxBtn = button('Adapter a ma vue', 'eyewear-flow__btn');
			actions.append(frameOnlyBtn, rxBtn);

			const choices = el('div', 'eyewear-flow__choices');
			const lensTypeRow = el('div', 'eyewear-flow__lens-types eyewear-flow__hidden');
			const lensTypeButtons = [];

			PACK_CATALOG.types.forEach((lensType) => {
				const lensTypeBtn = button(lensType.label, 'eyewear-flow__btn');
				lensTypeBtn.dataset.lensTypeKey = lensType.key;
				lensTypeRow.append(lensTypeBtn);
				lensTypeButtons.push(lensTypeBtn);
			});

			const packsGrid = el('div', 'eyewear-flow__packs eyewear-flow__hidden');
			const packCards = [];

			PACK_CATALOG.types.forEach((lensType) => {
				lensType.packs.forEach((pack) => {
					const card = el('div', 'eyewear-flow__card eyewear-flow__card--' + pack.key);
					const top = el('div', 'eyewear-flow__card-top');
					const packTitle = el('p', 'eyewear-flow__pack-title', pack.title);
					top.append(packTitle);
					if (pack.badge) {
						top.append(el('span', 'eyewear-flow__badge', pack.badge));
					}
					const desc = el('p', 'eyewear-flow__pack-desc', pack.description);
					const price = el('p', 'eyewear-flow__pack-price', pack.price != null ? formatMoney(pack.price) : '');
					card.append(top, desc, price);
					card.pack = { ...pack, lensTypeKey: lensType.key, lensTypeLabel: lensType.label };
					card.priceEl = price;
					packsGrid.append(card);
					packCards.push(card);
				});
			});

			const status = el('p', 'eyewear-flow__status', TEXTS.needChoice);
			const hint = el('p', 'eyewear-flow__hint', 'Les boutons panier seront actives apres vos choix.');
			const uploadTitle = el('p', 'eyewear-flow__hint eyewear-flow__upload-title', 'Ajouter votre ordonnance (PDF/JPG/PNG).');
			const uploadWrapper = el('div', 'eyewear-flow__upload eyewear-flow__hidden');

			choices.append(lensTypeRow, packsGrid, status, hint, uploadTitle, uploadWrapper);
			container.append(header, actions, choices);

			return {
				container,
				frameOnlyBtn,
				rxBtn,
				lensTypeButtons,
				packCards,
				lensTypeRow,
				packsGrid,
				status,
				hint,
				uploadTitle,
				uploadWrapper,
			};
		}

		function syncUi() {
			const ready = isReady();
			const needsUpload = state.mode === 'rx' && state.pack?.requiresUpload;

			ui.frameOnlyBtn.classList.toggle('is-active', state.mode === 'frame-only');
			ui.rxBtn.classList.toggle('is-active', state.mode === 'rx');

			ui.lensTypeRow.classList.toggle('eyewear-flow__hidden', state.mode !== 'rx');
			ui.packsGrid.classList.toggle('eyewear-flow__hidden', state.mode !== 'rx' || !state.lensType);

			ui.lensTypeButtons.forEach((lensTypeBtn) => {
				lensTypeBtn.classList.toggle('is-active', lensTypeBtn.dataset.lensTypeKey === state.lensType);
			});

			ui.packCards.forEach((card) => {
				const active = state.pack && card.pack.key === state.pack.key;
				const visible = card.pack.lensTypeKey === state.lensType;
				const disabled = card.pack.available === false;
				card.classList.toggle('is-active', !!active);
				card.classList.toggle('is-disabled', !!disabled);
				card.classList.toggle('eyewear-flow__hidden', !visible);
			});

			toggleButtons(ready);
			toggleUploadery(needsUpload);
			updateHiddenProperties();
			updateStatus(needsUpload);
		}

		function updateStatus(needsUpload) {
			let message = TEXTS.needChoice;
			let isError = true;

			if (!state.mode) {
				message = TEXTS.needChoice;
			} else if (state.mode === 'frame-only') {
				message = 'Monture seule choisie. Ajout direct au panier.';
				isError = false;
			} else if (!state.lensType) {
				message = TEXTS.needLensType;
			} else if (!state.pack) {
				message = TEXTS.needPack;
			} else if (needsUpload && !state.uploadDone) {
				message = TEXTS.needUpload;
			} else {
				message = TEXTS.ready;
				isError = false;

				if (state.pack && !state.pack.variantId) {
					message = TEXTS.missingVariant;
				}
			}

			ui.status.textContent = message;
			ui.status.className = 'eyewear-flow__status' + (isError ? ' eyewear-flow__status--error' : ' eyewear-flow__status--ok');
		}

		function updateHiddenProperties() {
			if (state.mode === 'frame-only') {
				hiddenPackProperty.value = 'Sans verres correcteurs';
				hiddenFlowProperty.value = 'Monture seule';
			} else if (state.pack) {
				hiddenPackProperty.value = state.pack.title;
				hiddenFlowProperty.value = state.pack.lensTypeLabel || getLensTypeLabel(state.lensType);
			} else if (state.mode === 'rx') {
				hiddenPackProperty.value = '';
				hiddenFlowProperty.value = getLensTypeLabel(state.lensType);
			}
		}

		function isReady() {
			if (!state.mode) return false;
			if (state.mode === 'frame-only') return true;
			if (!state.lensType || !state.pack) return false;
			if (state.pack.requiresUpload && !state.uploadDone) return false;
			return true;
		}

		function toggleUploadery(show) {
			if (uiRefs?.uploadWrapper) {
				uiRefs.uploadWrapper.classList.toggle('eyewear-flow__hidden', !show);
				if (show) moveUploaderyInto(uiRefs.uploadWrapper);
			}
			if (uiRefs?.uploadTitle) {
				uiRefs.uploadTitle.classList.toggle('eyewear-flow__hidden', !show);
			}
			if (uploaderyClassTarget) {
				uploaderyClassTarget.classList.toggle('eyewear-hide-uploadery', !show);
			}
		}

		function toggleButtons(enabled) {
			const addBtn = form.querySelector('[name="add"]');
			const shopPayBtn = form.querySelector('.shopify-payment-button__button');
			if (addBtn) addBtn.disabled = !enabled || state.pending;
			if (shopPayBtn) {
				const allowShopPay = enabled && !state.pending && state.mode !== 'rx';
				shopPayBtn.style.pointerEvents = allowShopPay ? '' : 'none';
				shopPayBtn.style.opacity = allowShopPay ? '' : '0.4';
			}
		}

		function buildItems() {
			const variantInput = form.querySelector('[name="id"]');
			const quantityInput = form.querySelector('[name="quantity"]');
			const mainVariantId = variantInput ? Number(variantInput.value) : null;
			const qty = quantityInput ? Number(quantityInput.value || 1) : 1;
			const mainProperties = collectMainItemProperties(form);

			const items = [];
			if (mainVariantId) {
				items.push({
					id: mainVariantId,
					quantity: qty,
					properties: mainProperties,
				});
			}

			if (state.pack?.variantId) {
				items.push({
					id: state.pack.variantId,
					quantity: qty,
					properties: {
						'Pack de verres': state.pack.title,
						Monture: hiddenFlowProperty.value || undefined,
					},
				});
			}

			return items;
		}

		function loadPackPrices() {
			const allPacks = PACK_CATALOG.types.flatMap((lensType) => lensType.packs);

			allPacks.forEach((pack) => {
				if (pack.price != null) {
					updatePackPriceDisplay(pack.key, formatMoney(pack.price));
				}
			});

			const variantIds = allPacks
				.filter((pack) => pack.variantId && (pack.price == null || Number.isNaN(Number(pack.price))))
				.map((pack) => pack.variantId);

			variantIds.forEach((id) => {
				fetch(`/variants/${id}.js`)
					.then((res) => res.json())
					.then((data) => {
						const priceStr = formatMoney(data.price);
						allPacks.forEach((pack) => {
							if (pack.variantId === id) {
								pack.price = data.price;
								pack.available = data.available !== false;
								updatePackPriceDisplay(pack.key, priceStr);
							}
						});
					})
					.catch(() => {});
			});
		}

		function getLensTypeLabel(lensTypeKey) {
			return LENS_TYPE_MAP[lensTypeKey]?.label || '';
		}

		function updatePackPriceDisplay(key, text) {
			ui.packCards.forEach((card) => {
				if (card.pack.key === key && card.priceEl) {
					card.priceEl.textContent = text;
				}
			});
		}

		function formatMoney(cents) {
			const amount = Number(cents || 0) / 100;
			return amount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
		}

		async function submitItems(items, redirectToCart) {
			if (state.pending) return;
			state.pending = true;
			toggleButtons(false);
			setStatus('Ajout en cours...', false);

			try {
				const response = nativeUploadFile
					? await postCartAddWithNativeFile(items)
					: await postCartAdd(buildCartRequest(items));
				if (response?.status || response?.errors) {
					throw new Error(response.message || response.errors || 'Erreur ajout panier');
				}

				const resource = (await fetchCartState()) || response;
				setStatus('Ajout au panier.', false);
				dispatchCartUpdateEvent(resource, response.sections);
				refreshCartBadges();

				if (redirectToCart || CONFIG.redirectAfterAdd) {
					window.location.href = '/cart';
				} else {
					document.dispatchEvent(new CustomEvent('cart:refresh', { detail: resource }));
				}
			} catch (err) {
				console.error(err);
				setStatus(err instanceof Error ? err.message : 'Impossible d ajouter au panier pour le moment.', true);
			} finally {
				state.pending = false;
				syncUi();
			}
		}

		function buildCartRequest(items) {
			const sections = getCartSectionIds();
			const body = { items };
			if (sections.length) {
				body.sections = sections.join(',');
				body.sections_url = window.location.pathname;
			}
			return body;
		}

		function getCartSectionIds() {
			return Array.from(document.querySelectorAll('cart-items-component'))
				.map((el) => el.dataset.sectionId)
				.filter(Boolean);
		}

		function postCartAdd(body) {
			return fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
				},
				body: JSON.stringify(body),
			}).then((res) => res.json());
		}

		async function postCartAddWithNativeFile(items) {
			const mainItem = items[0];
			const extraItems = items.slice(1);
			if (!mainItem) return postCartAdd(buildCartRequest(items));

			const formData = new FormData();
			formData.append('id', String(mainItem.id));
			formData.append('quantity', String(mainItem.quantity || 1));
			Object.entries(mainItem.properties || {}).forEach(([key, value]) => {
				if (value == null || value === '') return;
				formData.append(`properties[${key}]`, String(value));
			});
			formData.set(NATIVE_UPLOAD_PROPERTY_NAME, nativeUploadFile, nativeUploadFile.name);

			const sections = getCartSectionIds();
			if (sections.length) {
				formData.append('sections', sections.join(','));
				formData.append('sections_url', window.location.pathname);
			}

			const mainResponse = await postCartAddFormData(formData);
			if (mainResponse?.status || mainResponse?.errors) return mainResponse;

			if (extraItems.length) {
				return postCartAdd(buildCartRequest(extraItems));
			}
			return mainResponse;
		}

		function postCartAddFormData(formData) {
			return fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					Accept: 'application/json',
				},
				body: formData,
			}).then((res) => res.json());
		}

		async function fetchCartState() {
			try {
				const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
				if (!res.ok) return null;
				return await res.json();
			} catch (e) {
				console.error(e);
				return null;
			}
		}

		function getVariantQuantity(cart, variantId) {
			if (!cart || !Array.isArray(cart.items)) return 0;
			return cart.items
				.filter((item) => Number(item.variant_id) === Number(variantId))
				.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
		}

		function dispatchCartUpdateEvent(resource, sections) {
			const itemCount =
				resource?.item_count ||
				(resource?.items ? resource.items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0) : 0);
			const detail = {
				resource,
				data: {
					itemCount,
					source: 'eyewear-flow',
					sections,
				},
			};
			document.dispatchEvent(new CustomEvent('cart:update', { detail }));
		}

		function setStatus(text, isError) {
			ui.status.textContent = text;
			ui.status.className = 'eyewear-flow__status' + (isError ? ' eyewear-flow__status--error' : ' eyewear-flow__status--ok');
		}

		function bindUploaderyEvents() {
			document.addEventListener(
				'uploadSuccess',
				(event) => {
					const target = event.target;
					if (!(target instanceof HTMLElement) || !target.closest('#uploadery-container, form[data-uploadery]')) return;
					state.uploadDone = true;
					lastUploaderyFile = String(event?.detail?.file || '').trim();
					syncUploaderyPropertiesToProductForm(form);
					syncUi();
				},
				true,
			);

			document.addEventListener(
				'uploadError',
				(event) => {
					const target = event.target;
					if (!(target instanceof HTMLElement) || !target.closest('#uploadery-container, form[data-uploadery]')) return;
					state.uploadDone = false;
					lastUploaderyFile = '';
					clearUploaderyMirrors(form);
					syncUi();
				},
				true,
			);

			document.addEventListener(
				'change',
				(event) => {
					const input = event.target;
					if (!(input instanceof HTMLInputElement) || input.type !== 'file') return;
					const file = input.files?.[0];
					if (!file) return;
					lastUploaderyFile = file.name;

					if (input.hasAttribute(NATIVE_UPLOAD_INPUT_ATTR)) {
						nativeUploadFile = file;
						state.uploadDone = true;
						setStatus('Ordonnance ajoutee : ' + file.name, false);
						syncUi();
						return;
					}

					if (!input.closest('#uploadery-container')) return;

					window.setTimeout(() => {
						if (state.mode === 'rx' && state.pack?.requiresUpload && !state.uploadDone && lastUploaderyFile) {
							state.uploadDone = true;
							syncUploaderyPropertiesToProductForm(form);
							syncUi();
						}
					}, 1800);
				},
				true,
			);

			const tryBind = () => {
				if (!window.Shoppad || !window.Shoppad.$) {
					setTimeout(tryBind, 200);
					return;
				}
				window.Shoppad.$(document).on('uploadSuccess', 'form[data-uploadery]', (event) => {
					state.uploadDone = true;
					lastUploaderyFile = String(event?.originalEvent?.detail?.file || '').trim();
					syncUploaderyPropertiesToProductForm(form);
					syncUi();
				});
				window.Shoppad.$(document).on('uploadError', 'form[data-uploadery]', () => {
					state.uploadDone = false;
					lastUploaderyFile = '';
					clearUploaderyMirrors(form);
					syncUi();
				});
			};
			tryBind();
		}
	}

	function findProductForm() {
		// Cherche la forme principale hors quick-add
		const forms = Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"]')).filter(
			(f) => !f.closest('.quick-add-modal') && !f.closest('dialog'),
		);
		const form = forms[0];
		const productDetails = form?.closest('.product-details') || form?.closest('.product-information') || form?.parentElement;
		return { productDetails, form };
	}

	function observeForForm() {
		const observer = new MutationObserver(() => {
			const found = findProductForm();
			if (found.productDetails && found.form) {
				observer.disconnect();
				console.info('[eyewear-flow] Late init after observe');
				mountFlow(found.productDetails, found.form);
			}
		});
		observer.observe(document.body, { childList: true, subtree: true });
		setTimeout(() => {
			observer.disconnect();
			if (!mounted) console.error('[eyewear-flow] Unable to find product form (timeout).');
		}, 5000);
	}

	function moveUploaderyInto(target) {
		if (!target) return;
		const uploadery = document.querySelector('#uploadery-container');
		if (!uploadery) {
			ensureUploaderyWaitMessage(target);
			watchForUploadery(target);
			return;
		}
		mountUploaderyContainer(uploadery, target);
	}

	function ensureUploaderyWaitMessage(target) {
		if (!target || target.querySelector('[data-uploadery-wait]')) return;
		const wait = document.createElement('div');
		wait.className = 'eyewear-flow__upload-wait';
		wait.dataset.uploaderyWait = '1';
		wait.textContent = 'Chargement du module ordonnance...';
		target.appendChild(wait);
	}

	function watchForUploadery(target) {
		if (!target || uploaderyMoveObserver || uploaderyMoveRetryTimer) return;
		const startedAt = Date.now();

		const tryMove = () => {
			const uploadery = document.querySelector('#uploadery-container');
			if (uploadery) {
				stopUploaderyWatch();
				mountUploaderyContainer(uploadery, target);
				return;
			}

			if (Date.now() - startedAt >= UPLOADERY_MOVE_TIMEOUT) {
				stopUploaderyWatch();
				const wait = target.querySelector('[data-uploadery-wait]');
				if (wait) wait.textContent = 'Module ordonnance indisponible. Rechargez la page ou contactez-nous.';
				ensureNativeUploadFallback(target);
				return;
			}

			uploaderyMoveRetryTimer = window.setTimeout(tryMove, 300);
		};

		uploaderyMoveObserver = new MutationObserver(tryMove);
		uploaderyMoveObserver.observe(document.body, { childList: true, subtree: true });
		tryMove();
	}

	function stopUploaderyWatch() {
		if (uploaderyMoveObserver) {
			uploaderyMoveObserver.disconnect();
			uploaderyMoveObserver = null;
		}
		if (uploaderyMoveRetryTimer) {
			window.clearTimeout(uploaderyMoveRetryTimer);
			uploaderyMoveRetryTimer = null;
		}
	}

	function mountUploaderyContainer(uploadery, target) {
		if (!uploadery || !target) return;
		uploadery.classList.add('eyewear-flow__uploadery');
		if (uploadery.parentElement !== target) {
			target.innerHTML = '';
			target.appendChild(uploadery);
		} else {
			target.querySelectorAll('[data-uploadery-wait]').forEach((el) => el.remove());
		}
		const normalized = normalizeUploaderyLabels(uploadery);
		addUploadClickFallback(uploadery);
		observeUploaderyLabels(uploadery, normalized);
		if (normalized) {
			removeNativeUploadFallback(target);
		} else {
			ensureNativeUploadFallback(target);
		}
	}

	function ensureNativeUploadFallback(target) {
		if (!target || target.querySelector('[data-eyewear-native-upload-fallback]')) return;
		target.querySelectorAll('[data-uploadery-wait]').forEach((el) => el.remove());

		const label = document.createElement('label');
		label.className = 'eyewear-flow__native-upload';
		label.dataset.eyewearNativeUploadFallback = '1';

		const text = document.createElement('span');
		text.className = 'eyewear-flow__native-upload-text';
		text.textContent = 'Partager votre ordonnance';

		const input = document.createElement('input');
		input.type = 'file';
		input.name = NATIVE_UPLOAD_PROPERTY_NAME;
		input.accept = '.pdf,.jpg,.jpeg,.png,image/jpeg,image/png,application/pdf';
		input.setAttribute(NATIVE_UPLOAD_INPUT_ATTR, '1');

		const help = document.createElement('small');
		help.className = 'eyewear-flow__native-upload-help';
		help.textContent = 'PDF, JPG ou PNG.';

		label.append(text, input, help);
		target.appendChild(label);
	}

	function removeNativeUploadFallback(target) {
		if (!target) return;
		target.querySelectorAll('[data-eyewear-native-upload-fallback]').forEach((el) => el.remove());
	}

	function normalizeUploaderyLabels(uploadery) {
		const form = uploadery.closest('form') || uploadery.querySelector('form');
		if (!form) return false;
		const labels = Array.from(form.querySelectorAll('label'));
		if (labels.length === 0) return false;

		// Keep only the first label
		const mainLabel = labels[0];
		// Remove overlays that can block clicks
		form.querySelectorAll('.sp-validate-overlay').forEach((el) => el.remove());
		labels.slice(1).forEach((l) => l.remove());

		const titleNode = mainLabel.querySelector('.eyewear-uploadery-title');
		const fileBlock =
			mainLabel.querySelector('.spb-fileupload') ||
			mainLabel.querySelector('input[type="file"]')?.closest('div') ||
			null;
		const fileInput =
			mainLabel.querySelector('input[type="file"]') || fileBlock?.querySelector?.('input[type="file"]');

		if (titleNode && fileInput) {
			// Normalize text to avoid emoji/garbage from Uploadery custom script
			titleNode.textContent = 'Partager votre ordonnance';
			mainLabel.dataset.eyewearNormalized = '1';
			return true;
		}

		if (!fileBlock) {
			delete mainLabel.dataset.eyewearNormalized;
			return false;
		}

		// Rebuild the label to avoid duplicated text nodes
		fileBlock.remove();
		mainLabel.innerHTML = '';
		const title = document.createElement('div');
		title.className = 'eyewear-uploadery-title';
		title.textContent = 'Partager votre ordonnance';
		mainLabel.appendChild(title);
		mainLabel.appendChild(fileBlock);
		mainLabel.dataset.eyewearNormalized = '1';
		return !!fileBlock.querySelector('input[type="file"]');
	}

	function observeUploaderyLabels(uploadery, alreadyDone = false) {
		// Keep observing (debounced) to strip overlays and keep click fallback, but avoid tight loops
		let ticking = false;
		const obs = new MutationObserver(() => {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(() => {
				const done = normalizeUploaderyLabels(uploadery);
				if (done) {
					addUploadClickFallback(uploadery);
					removeNativeUploadFallback(uploadery.closest('.eyewear-flow__upload'));
				}
				ticking = false;
				if (done) obs.disconnect();
			});
		});
		obs.observe(uploadery, { childList: true, subtree: true });
		if (!alreadyDone) {
			setTimeout(() => {
				const done = normalizeUploaderyLabels(uploadery);
				if (done) {
					addUploadClickFallback(uploadery);
					removeNativeUploadFallback(uploadery.closest('.eyewear-flow__upload'));
				}
				if (done) obs.disconnect();
			}, 50);
		}
	}

	function addUploadClickFallback(uploadery) {
		const wrapper = uploadery.closest('.eyewear-flow__upload') || uploadery;
		if (!wrapper || wrapper.dataset.eyewearClickBound === '1') return;
		wrapper.dataset.eyewearClickBound = '1';
		wrapper.addEventListener('click', (ev) => {
			const input = uploadery.querySelector('input[type="file"]');
			if (!input) return;
			const target = ev.target;
			if (target instanceof HTMLElement && (target.tagName === 'INPUT' || target.closest('input[type="file"]'))) return;
			input.click();
		});
	}

		// --- Cart badge refresh helper ---
	function refreshCartBadges() {
		fetch('/cart.js', { headers: { Accept: 'application/json' } })
			.then((r) => r.json())
			.then((cart) => {
				const count = cart?.item_count || 0;
				const targets = document.querySelectorAll(
					'[data-cart-count], [data-cart-count-bubble], .cart-count-bubble .count, .header__icon--cart .count'
				);
				targets.forEach((el) => {
					el.textContent = count;
					const bubble = el.closest('.cart-count-bubble');
					if (bubble) bubble.classList.toggle('hidden', count === 0);
				});
			})
			.catch((err) => console.warn('[cart-badge] refresh error', err));
	}

	// Écoute les événements de mise à jour de panier
	['cart:update', 'cart:refresh', 'ajaxCart:updated', 'cart:updated'].forEach((evt) => {
		document.addEventListener(evt, () => setTimeout(refreshCartBadges, 60));
	});

	// Fallback si le thème ne déclenche pas d’événement sur la suppression
	document.addEventListener('click', (e) => {
		if (e.target.closest('[data-remove-from-cart], [data-cart-remove], .cart-remove, button[name="remove"]')) {
			setTimeout(refreshCartBadges, 200);
		}
	});

	function ensureHiddenInput(form, name, value) {
		let input = form.querySelector(`input[name="${name}"]`);
		if (!input) {
			input = document.createElement('input');
			input.type = 'hidden';
			input.name = name;
			form.appendChild(input);
		}
		input.value = value;
		return input;
	}

	function readFormPropertyEntries(root) {
		if (!root) return [];

		return Array.from(root.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]'))
			.map((field) => {
				if (!(field instanceof HTMLElement)) return null;
				if (field instanceof HTMLInputElement) {
					if (field.disabled || field.type === 'file') return null;
					if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return null;
					return [field.name, String(field.value || '').trim()];
				}
				if (field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement) {
					if (field.disabled) return null;
					return [field.name, String(field.value || '').trim()];
				}
				return null;
			})
			.filter((entry) => Array.isArray(entry) && entry[0] && entry[1]);
	}

	function readUploaderyPropertyEntries() {
		const uploadery = document.querySelector('#uploadery-container');
		if (!uploadery) return [];

		const roots = [uploadery];
		const uploaderyForm = uploadery.querySelector('form[data-uploadery]') || uploadery.querySelector('form');
		if (uploaderyForm) roots.push(uploaderyForm);

		const entries = [];
		const seen = new Set();
		roots.forEach((root) => {
			readFormPropertyEntries(root).forEach(([name, value]) => {
				const key = `${name}::${value}`;
				if (seen.has(key)) return;
				seen.add(key);
				entries.push([name, value]);
			});
		});

		if (!entries.length && lastUploaderyFile) {
			entries.push([UPLOADERY_FALLBACK_PROPERTY_NAME, lastUploaderyFile]);
		}

		return entries;
	}

	function syncUploaderyPropertiesToProductForm(form) {
		if (!form) return;

		const mirroredNames = new Set();
		readUploaderyPropertyEntries().forEach(([name, value]) => {
			const input = ensureHiddenInput(form, name, value);
			input.setAttribute(MIRRORED_UPLOADERY_INPUT_ATTR, '1');
			mirroredNames.add(name);
		});

		form.querySelectorAll(`input[${MIRRORED_UPLOADERY_INPUT_ATTR}="1"]`).forEach((input) => {
			if (!mirroredNames.has(input.name)) {
				input.remove();
			}
		});
	}

	function clearUploaderyMirrors(form) {
		if (!form) return;
		form.querySelectorAll(`input[${MIRRORED_UPLOADERY_INPUT_ATTR}="1"]`).forEach((input) => input.remove());
	}

	function collectMainItemProperties(form) {
		const properties = {};
		readFormPropertyEntries(form).forEach(([name, value]) => {
			const match = /^properties\[(.+)\]$/.exec(name);
			if (!match) return;
			const key = match[1];
			if (!key || key === '_eyewear_flow_token') return;
			properties[key] = value;
		});
		return properties;
	}

	function generateFlowToken() {
		return `ewf_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
	}

	function savePendingPack(data) {
		try {
			sessionStorage.setItem(PENDING_PACK_STORAGE_KEY, JSON.stringify(data));
		} catch (error) {
			console.warn('[eyewear-flow] Unable to persist pending pack', error);
		}
	}

	function readPendingPack() {
		try {
			const raw = sessionStorage.getItem(PENDING_PACK_STORAGE_KEY);
			if (!raw) return null;
			return JSON.parse(raw);
		} catch (error) {
			console.warn('[eyewear-flow] Unable to read pending pack', error);
			return null;
		}
	}

	function clearPendingPack(token) {
		try {
			const current = readPendingPack();
			if (!current) return;
			if (token && current.token !== token) return;
			sessionStorage.removeItem(PENDING_PACK_STORAGE_KEY);
			pendingPackRetryCount = 0;
			if (pendingPackRetryTimer) {
				clearTimeout(pendingPackRetryTimer);
				pendingPackRetryTimer = null;
			}
		} catch (error) {
			console.warn('[eyewear-flow] Unable to clear pending pack', error);
		}
	}

	function schedulePendingPackProcessing(delay = PENDING_PACK_RETRY_DELAY) {
		if (pendingPackRetryTimer) {
			clearTimeout(pendingPackRetryTimer);
		}
		pendingPackRetryTimer = setTimeout(() => {
			pendingPackRetryTimer = null;
			processPendingPackAddition();
		}, delay);
	}

	function fetchCartJson() {
		return fetch('/cart.js', {
			headers: {
				Accept: 'application/json',
			},
		}).then((response) => (response.ok ? response.json() : null));
	}

	function getCartSectionIds() {
		return Array.from(document.querySelectorAll('cart-items-component'))
			.map((el) => el.dataset.sectionId)
			.filter(Boolean);
	}

	function postCartAdd(body) {
		return fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify(body),
		}).then((res) => res.json());
	}

	function buildCartRequest(items) {
		const sections = getCartSectionIds();
		const body = { items };
		if (sections.length) {
			body.sections = sections.join(',');
			body.sections_url = window.location.pathname;
		}
		return body;
	}

	function getItemPropertyValue(item, key) {
		if (!item || !item.properties || typeof item.properties !== 'object') return '';
		return String(item.properties[key] || '').trim();
	}

	function getCartItemQuantityByToken(cart, variantId, token) {
		if (!cart || !Array.isArray(cart.items) || !variantId || !token) return 0;
		return cart.items
			.filter(
				(item) =>
					Number(item.variant_id) === Number(variantId) &&
					getItemPropertyValue(item, '_eyewear_flow_token') === token,
			)
			.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
	}

	async function processPendingPackAddition() {
		const pending = readPendingPack();
		if (!pending || pendingPackProcessing) return;
		if (!pending.packVariantId || !pending.quantity || !pending.token) {
			clearPendingPack();
			return;
		}
		if (pending.createdAt && Date.now() - Number(pending.createdAt) > 15 * 60 * 1000) {
			clearPendingPack(pending.token);
			return;
		}

		pendingPackProcessing = true;
		try {
			const cart = await fetchCartJson();
			if (!cart) {
				queuePendingPackRetry();
				return;
			}

			const frameQty = getCartItemQuantityByToken(cart, pending.frameVariantId, pending.token);
			if (frameQty < Number(pending.quantity)) {
				queuePendingPackRetry();
				return;
			}

			const packQty = getCartItemQuantityByToken(cart, pending.packVariantId, pending.token);
			if (packQty >= Number(pending.quantity)) {
				clearPendingPack(pending.token);
				document.dispatchEvent(
					new CustomEvent('eyewear-flow:pending-pack-complete', { detail: { token: pending.token, alreadyPresent: true } })
				);
				return;
			}

			const response = await postCartAdd(
				buildCartRequest([
					{
						id: Number(pending.packVariantId),
						quantity: Number(pending.quantity),
						properties: {
							'Pack de verres': pending.packTitle || undefined,
							Monture: pending.lensTypeLabel || undefined,
							_eyewear_flow_token: pending.token,
						},
					},
				]),
			);

			if (response?.status || response?.errors) {
				throw new Error(response.message || response.errors || 'Erreur ajout automatique du pack');
			}

			const nextCart = await fetchCartJson();
			if (getCartItemQuantityByToken(nextCart, pending.packVariantId, pending.token) >= Number(pending.quantity)) {
				clearPendingPack(pending.token);
				pendingPackRetryCount = 0;
			}

			document.dispatchEvent(new CustomEvent('cart:refresh', { detail: nextCart || response }));
			document.dispatchEvent(
				new CustomEvent('eyewear-flow:pending-pack-complete', { detail: { token: pending.token } })
			);
		} catch (error) {
			console.error('[eyewear-flow] Pending pack addition failed', error);
			clearPendingPack(pending.token);
			document.dispatchEvent(
				new CustomEvent('eyewear-flow:pending-pack-error', {
					detail: { token: pending.token, message: error instanceof Error ? error.message : String(error) },
				}),
			);
		} finally {
			pendingPackProcessing = false;
		}
	}

	function queuePendingPackRetry() {
		pendingPackRetryCount += 1;
		if (pendingPackRetryCount > PENDING_PACK_MAX_RETRIES) {
			console.warn('[eyewear-flow] Pending pack retry limit reached');
			return;
		}
		schedulePendingPackProcessing(PENDING_PACK_RETRY_DELAY);
	}

	function el(tag, className, text) {
		const node = document.createElement(tag);
		if (className) node.className = className;
		if (text) node.textContent = text;
		return node;
	}

	function button(text, className) {
		const btn = document.createElement('button');
		btn.type = 'button';
		btn.className = className;
		btn.textContent = text;
		return btn;
	}
})();
